import $ from "jquery";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Row } from "react-foundation";
import { Field } from "redux-form";

import Tick from "components/Tick";
import Loading from "components/Loading";
import Image from "components/Image";
import SlickSlider from "components/SlickSlider";

import { getConservatoryTypes, updatePreviousSelection } from "actions";
import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";

class SelectType extends Component {
    renderImage(value, id) {
        return (
            <div key={id}>
                <div className="slick-slide-image-container">
                    <Tick />
                    <Image src={value.externalImageUrl} alt="" className="slick-slide-image" />
                </div>
                <p className={"slick-slide-title"}>{value.name}</p>
            </div>
        );
    }

    render() {
        let { types, input } = this.props;
        if ($.isEmptyObject(types)) {
            return <Loading />;
        }

        return (
            <div>
                <Row isColumn>
                    <SlickSlider values={types} selectedId={input.value} onDisplay={this.renderImage.bind(this)} onChange={input.onChange} />
                </Row>
                <InputError metas={this.props.meta} />
            </div>
        );
    }
}
class TypeForm extends Component {
    componentDidMount() {
        this.props.getConservatoryTypes();
    }

    onSubmit(values) {
        let conservatoryTypeId = values.ConservatoryId;
        this.props.updatePreviousSelection({
            ConservatoryTypeId: conservatoryTypeId
        });

        this.props.onSubmit();
    } 

    render() {
        const { previousPage, styles } = this.props;
        return (
            <form className="TypeForm" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader title={"Pick your style"} subtitle={""}/>
                <SeparatingLine />
                <Field name="ConservatoryTypeId" component={SelectType} types={styles} />
                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    return {
        styles: state.Conservatory.Styles
    };
};

export default connect(mapStateToProps, { getConservatoryTypes, updatePreviousSelection })(TypeForm);



// WEBPACK FOOTER //
// ./src/containers/ConservatoryForm/TypeForm.js